import React, { useEffect } from "react";
import InputTypeNumber from "../../../common/components/InputTypeNumber/InputTypeNumber";

const CommonCostEstimation = ({
	label,
	name,
	disabled = false,
	values,
	errors,
	touched,
	handleChange,
	handleBlur,
	handleSubmit,
	setFieldValue,
	setFieldTouched,
	setFieldError,
	isSubmitting,
}) => {
	return (
		<>
			<div className="grid grid-cols-2 mb-4 gap-8 ">
				<div>
					<p
						className={`${
							label === "Agreement Value (Basic Cost + GST)" ||
							label === "Total Other Charges" ||
							label === "Document Cost"
								? "font-bold text-black-400 text-left md:w-32 pt-4 pb-4"
								: "text-black-400 text-left md:w-32  pt-4 pb-4"
						}`}
					>
						{label}
					</p>
				</div>
				<div>
					<InputTypeNumber
						name={name}
						value={values[name] ? values[name] : ""}
						maxLength={10}
						minLength={0}
						onChange={handleChange}
						onBlur={handleBlur}
						disabled={disabled}
						error={touched[name] && errors[name]}
						errorMsg={errors[name]}
						touched={touched[name]}
						setFieldValue={setFieldValue}
						setFieldTouched={setFieldTouched}
						setFieldError={setFieldError}
						inputStyle={
							disabled
								? {
										fontWeight: "bolder",
										paddingLeft: "40px",
										letterSpacing: "1px",
								  }
								: {
										fontWeight: "normal",
										paddingLeft: "40px",
										letterSpacing: "1px",
								  }
						}
						showInText={false}
					/>
				</div>
			</div>
		</>
	);
};
export default CommonCostEstimation;
